<template>
  <ui-modal-layout :title="tr('Would you like to turn off the campaign too?')" :icon="StatusIcon" stacked>
    <div class="flex flex-col gap-3 text-muted-foreground">
      <p class="m-0">{{ tr('The campaign is currently active, in which the desired automation is being worked to be turned off.') }}</p>
      <p class="m-0">{{ tr('You can choose to disable only the automation: in this case, no new advertisements will be created, but the existing ones will continue to run.') }}</p>
      <p class="m-0">{{ tr('You can also disable the associated campaign along with the automation: in this case, the existing ads will also be paused.') }}</p>
    </div>

    <template #footer>
      <ui-button variant="outline" :disabled="isLoading" @click="() => switchOnlyRule()">
        <loader-circle-icon v-if="loadingRule" class="animate-spin" />
        {{ tr('Only switching the Automation') }}
      </ui-button>
      <ui-button :disabled="isLoading" @click="() => switchRuleWithCampaign()">
        <loader-circle-icon v-if="loadingRuleWithCampaign" class="animate-spin" />
        {{ tr('Turn off Automation and Campaign') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { LoaderCircle, PowerOff } from '@lucide/vue';
import { markRaw } from 'vue';

import Rule from '@/entities/Rule';
import RuleService from '@/services/Rule.js';

export default {
  name: 'RuleCampaignStatusChangeModalContent',
  components: {
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    rule: {
      type: Rule,
      required: true,
    },
  },
  data: () => ({
    StatusIcon: markRaw(PowerOff),
    loadingRule: false,
    loadingRuleWithCampaign: false,
  }),
  computed: {
    id() {
      return this.rule.id;
    },
    newStatus() {
      return !this.rule.active;
    },
    isLoading() {
      return this.loadingRule || this.loadingRuleWithCampaign;
    },
  },
  methods: {
    switchOnlyRule() {
      if (this.isLoading) {
        return;
      }
      this.loadingRule = true;

      const promise = RuleService.changeStatus(this.id, this.newStatus);
      this.handlePromise(promise);
    },
    switchRuleWithCampaign() {
      if (this.isLoading) {
        return;
      }
      this.loadingRuleWithCampaign = true;

      const promise = RuleService.changeStatus(this.id, this.newStatus, true);
      this.handlePromise(promise);
    },
    onSuccess(newValues) {
      this.rule.updateWith(newValues);
      this.$fullscreenModal.closeAll();
    },
    handlePromise(promise) {
      promise.then(rule => this.onSuccess(rule))
        .catch(err => {
          this.error(err);
          this.rule.active = !this.newStatus;
        })
        .finally(() => {
          this.loadingRule = false;
          this.loadingRuleWithCampaign = false;
        });
    },
  },
};
</script>
